import { Component } from '@angular/core';
import { FnGridAbstractCell } from '../../model/fn-grid-abstract-cell.model';

@Component({
	selector: 'fn-grid-date',
	templateUrl: 'fn-grid-date.component.html',
	styleUrls: ['fn-grid-date.component.scss'],
})
export class FnGridDateComponent extends FnGridAbstractCell {}
